import { useMemo } from "react";

import {
  getRideHubPresence,
  HubSegmentEnum,
  IRideDto,
  useSystemParams,
} from "@ryde/shared";

export interface IRideHubInfo {
  hasMain: boolean;
  hasPersonal: boolean;
  hubSegment: HubSegmentEnum | undefined;
  hasCompanionPassengers: boolean;
}

export const useRideHubInfo = (
  rideDto: Partial<IRideDto> | undefined,
): IRideHubInfo | null => {
  const { enableHubsLogic } = useSystemParams();

  return useMemo(() => {
    if (!enableHubsLogic) {
      return null;
    }

    return getRideHubPresence(rideDto);
  }, [enableHubsLogic, rideDto]);
};
